export enum Variant {
  success = "success",
  info = "info",
  warning = "warning",
  danger = "danger",
}
